__turbopack_context__.v({
  "checkbox": "index-module-scss-module__tyylZq__checkbox",
  "control": "index-module-scss-module__tyylZq__control",
  "hasError": "index-module-scss-module__tyylZq__hasError",
  "multiline": "index-module-scss-module__tyylZq__multiline",
});
